import React, { useState } from "react";
import Label from "../../../components/ui/label/Label";
import CKEditorComponent from "../../../components/finalForms/ui/inputs/ckEditor/CKEditor";
import Buttons from "../../../components/ui/button/Buttons";
import { AppIcons } from "../../../data/appIcons";

const EditTaskDescription = ({ taskId, description, updateTask, togglePopup }) => {
  const [tempDescription, setTempDescription] = useState(description || "");

  const handleSave = () => {
    if (tempDescription?.trim() !== description?.trim()) {
      updateTask(tempDescription);
    }
    togglePopup();
  };

  const handleCancel = () => {
    togglePopup();
  };

  return (
   <>
      <Label labelName="Task Description" />
      <CKEditorComponent
        onCKEditorChange={(newData) => setTempDescription(newData)}
        data={tempDescription}
      />

      <div className="row mt-2">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={handleCancel}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              onClick={handleSave}
              buttonText="Update"
              imagePath={AppIcons.AddIcon}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTaskDescription;
